// extracted by css-extract-rspack-plugin
export default {"input":"input-G061iG"};